import type { FocusEvent } from 'react';

/**
 * Chromium leaves a partly visible element where it is when it receives
 * focus, so a keyboard user could land on a control cut off at the edge of a
 * horizontally scrolling strip (finding sections, Explore tabs). Reveal the
 * whole control within its strip; do nothing when it is already visible.
 */
export function revealInStrip(event: FocusEvent<HTMLElement>) {
  event.currentTarget.scrollIntoView({ block: 'nearest', inline: 'nearest' });
}
